"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiOther {
    static reportLog(body) {
        let url = "/ElevateReportLog";
        return Client_1.default.httpGCFPost(url, body);
    }
}
exports.default = ApiOther;
